/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconChevronsDownRight = createReactComponent("outline", "chevrons-down-right", "IconChevronsDownRight", [["path", { "d": "M13 5v8h-8", "key": "svg-0" }], ["path", { "d": "M17 9v8h-8", "key": "svg-1" }]]);

export { IconChevronsDownRight as default };
//# sourceMappingURL=IconChevronsDownRight.mjs.map
